import imgTg from "../../assets/images/soc_tg.webp"
import imgX from "../../assets/images/soc_x.webp"
import imgMoo from "../../assets/images/soc_moo.webp"
import imgTgComplete from "../../assets/images/soc_tg_complete.webp"
import imgXComplete from "../../assets/images/soc_x_complete.webp"
import imgMooComplete from "../../assets/images/soc_moo_complete.webp"

const socialData = [
    {
        completeState: 2,
        imgSrc: imgTg,
        imgSrcComplete: imgTgComplete,
        count: "01",
        title: "Telegram",
        text: "Join MooArmy in Telegram.",
        textBtn: "Join"
    },
    {
        completeState: 4,
        imgSrc: imgX,
        imgSrcComplete: imgXComplete,
        count: "02", title: "Twitter",
        text: "Follow MooArmy on Twitter.",
        textBtn: "Follow"
    },
    {
        completeState: 8,
        imgSrc: imgMoo,
        imgSrcComplete: imgMooComplete,
        count: "03",
        title: "#MOOARMY AIRDROP",
        text: "Get In Early.",
        textBtn: "Join Airdrop"
    },
]

export default socialData;